import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getDocumentComments, type DocumentCommentResponse } from '../api';
import { reviewerQueryKeys } from './useDocumentResult';

/**
 * Loads the comment thread of a document job from `GET /documents/{id}/comments`.
 * Lazy: callers pass `enabled: false` until the comments panel is opened.
 */
export function useDocumentComments(
  jobId: string,
  options: { enabled?: boolean } = {},
): UseQueryResult<DocumentCommentResponse[]> {
  return useQuery({
    queryKey: reviewerQueryKeys.comments(jobId),
    queryFn: ({ signal }) => getDocumentComments(jobId, signal),
    enabled: (options.enabled ?? true) && jobId.length > 0,
    staleTime: 30_000,
    retry: 1,
  });
}
